export default "__VITE_ASSET__EcYNN1JJ__"